import { Component, OnInit, OnDestroy } from '@angular/core';
import {default as GridColumnsJSON} from 'app/Shared/Constant/Grid Column Names/monitoring-columns.json';
import { GridService } from 'app/Shared/Services/grid.service';
import { EmitterService } from 'app/Shared/Services/emitter.service';
import { UserService } from 'app/Shared/Services/user.service';
import { DatePipe } from '@angular/common';
import { APIURL } from 'app/Shared/Constant/API_Urls';
import { HttpErrorResponse } from '@angular/common/http';
import { UrlsService } from 'app/Shared/Services/urls.service';
import { SharedHttpClientService } from 'app/Shared/Services/shared-http-client.service';
import { Subscription } from 'rxjs';
import { FilterPanelComponent } from "../../filter-panel/filter-panel.component";
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import { GridComponent } from 'app/Shared/Modules/non-transactional-grid/grid/grid.component';
import { MessageService } from 'primeng/api';
import { ConstantService } from 'app/Shared/Services/constant-service';
import { generateCsv, asBlob } from "export-to-csv";
import { saveAs } from 'file-saver';
import { ToastModule } from 'primeng/toast';

@Component({
    selector: 'app-monitoring',
    templateUrl: './monitoring.component.html',
    imports: [FilterPanelComponent, MatProgressSpinnerModule, GridComponent, ToastModule],
    providers: [],
    styleUrls: ['./monitoring.component.scss']
})
export class MonitoringComponent implements OnInit, OnDestroy {
    
  GridColumns = GridColumnsJSON;
  panelOpenState: boolean;
  dataset1: any[] = [];
  DefaultFilterArray: any = [];
  isLoadingResults = true;
  Limit: any = { 'Start': '', 'End': '' };
  totalRecords: any;
  rowcount!: number;
  startLimit: any = 0;
  endLimit!: number;
  subscription!: Subscription;
  TotalRecords:any;
  previousLimit: any = { 'Start': '', 'End': '' };

  constructor(
    private gridService: GridService,
    private emitterService: EmitterService,
    private userService: UserService,
    private datePipe: DatePipe,
    private sharedHttpClientService: SharedHttpClientService,
    private urlsService: UrlsService,
    private messageService: MessageService,
    public constantService: ConstantService
    ) {
        this.panelOpenState = false;
  }

  ngOnInit(): void {
    this.rowcount = this.gridService.getGridRowsCount();
    this.Limit = { 'Start': '0', 'End': this.rowcount };
    this.totalRecords = this.rowcount;
    this.dataset1 = [];
    this.defaultFilter();
    this.subscription = this.emitterService.reloadMainDashBoard.subscribe(value => {
      if (value) {
        this.getData();
      }
    });
  }

  FilterApplyFilterEvent(event:any) {
    this.emitterService.isResetGridLimit.emit(true);
    this.DefaultFilterArray = [];
    this.DefaultFilterArray = event;
    this.startLimit = 0;
    this.Limit.Start = 0;
    this.getData();
  }

  GridChangeLimitEvent(event: any) {
    this.Limit = event;
    this.getData();
  }

  defaultFilter() {
      this.DefaultFilterArray = [
        {
          "isdefault": "true",
          "label": "Date",
          "columnname": "startdttm",
          "filterby": "",
          "values": [
           this.userService.LogsLastExcecutionReportDate,
           this.userService.LogsLastExcecutionReportDate
          ],
          "time": "",
          "datatype": "DateRange",
          "disabled": "true",
          "dropdown": "",
          "dropdownvalue": ""
        },
        { 'isdefault': 'true', 'label': 'Report Date', 'columnname': 'Report_Date', 'filterby': 'IS', 'values': '', 
          'time': '', 'datatype': 'Date', 'disabled': 'true', 'dropdown': '', 'dropdownvalue': '' },
        { 'isdefault': 'true', 'label': 'File Name', 'columnname': 'File_Name', 'filterby': 'IS', 'values': '', 'time': '',
          'datatype': 'String', 'disabled': 'true', 'dropdown': '', 'dropdownvalue': '' },
        {
          'isdefault': 'true', 'label': 'Description', 'columnname': 'Process_Remark', 'filterby': 'IS', 'values': '', 
          'time': '', 'datatype': 'String', 'disabled': 'true', 'dropdown': '', 'dropdownvalue': '' },
        {
          'isdefault': 'true', 'label': 'File Row #', 'columnname': 'File_Record_Count', 'filterby': 'IS', 'values': '', 
          'time': '', 'datatype': 'String', 'disabled': 'true', 'dropdown': '', 'dropdownvalue': '' },
        {
          'isdefault': 'true', 'label': 'Rejected Row #', 'columnname': 'Rejected_Record_Count', 'filterby': 'IS', 'values': '', 
          'time': '', 'datatype': 'String', 'disabled': 'true', 'dropdown': '', 'dropdownvalue': '' },
        {
          'isdefault': 'true', 'label': 'Success Flag', 'columnname': 'Success_Flag', 'filterby': 'IS', 'values': '', 
          'time': '', 'datatype': 'String', 'disabled': 'true', 'dropdown': '', 'dropdownvalue': '' }
      ];
      this.getData();
  }

  getData() {
    this.isLoadingResults = true;
    this.gridService.prepareData(APIURL.system_Monitor_Logs, this.DefaultFilterArray, this.Limit, 'System-Monitor')
      .subscribe({
        next: (Element:any) => {
          this.isLoadingResults = false;
          let dataset: any;
          dataset = Element;
          this.dataset1 = dataset.data;
          this.totalRecords = dataset.totalCount;
        },
        error: (e:HttpErrorResponse) => {
          this.isLoadingResults = false;
        }
    }); 
  }

  exportToCSV(event:any) {
    let initialTime = new Date().toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', second: '2-digit'});
    let exportLimt: any;
    this.previousLimit.Start = event.Start;
    this.previousLimit.End = event.End;

    event = event.event;
    if (event.isExportMaxRows) {
      exportLimt = { 'Start': this.constantService.NUMBER_0, 'End': this.constantService.NUMBER_MAX_EXPORT_ROWS };
    } else {
      exportLimt = this.previousLimit;
    }

    const filterData = JSON.parse(JSON.stringify(this.DefaultFilterArray));
    filterData[0].values[0] = this.userService.getyyyyMMddDateFormate(JSON.parse(JSON.stringify(filterData[0].values[0])));
    filterData[0].values[1] = this.userService.getyyyyMMddDateFormate(JSON.parse(JSON.stringify(filterData[0].values[1])));

    let payload = {
      data: JSON.parse(JSON.stringify(filterData)),
      mpid: this.userService.getActiveMPID(),
      startLimit: exportLimt.Start.toString(),
      endLimit: exportLimt.End.toString()
    }
    this.sharedHttpClientService.post(
      this.urlsService.setAPIURl(
        APIURL.system_Monitor_Logs
      ),
      payload
    ).subscribe({
      next: (Element:any) => {
        let dataset: any = Element;
        dataset = dataset.data;
        if (dataset.length > 0) {
              const mkConfig:any = {
                fieldSeparator: ',',
                quoteStrings: '"',
                decimalSeparator: '.',
                showLabels: true,
                showTitle: true,
                title: 'RSMS_System_Monitor_Log_' + this.userService.getyyyyMMddDateFormate(new Date()),
                useTextFile: false,
                useBom: true,
                useKeysAsHeaders: true,
              };
              let filename = this.userService.getActiveMPID() +'_RSMS_System_Monitor_Log_' + this.userService.getyyyyMMdd_HH_MM_SSDateFormate(new Date())+'.csv';
              const csv = generateCsv(mkConfig)(dataset);
              const blob = asBlob(mkConfig)(csv);
              saveAs(blob,filename);
      
              this.userService.logUserActivity('Export CSV', null, {
                'Text1': 'File Download Successfully | ' + (dataset.length > 0 ? dataset.length : 0) + ' records downloaded with file name: ' +  filename +' with start time: ' + initialTime + ' and end time: '
                 + new Date().toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', second: '2-digit'}),
                'Text2': 'User Filter Parameters: ' + JSON.stringify(this.DefaultFilterArray.filter((filterParam:any) => (filterParam.values != '' || filterParam.values.length > 0)))
              });
            } else {
              this.messageService.add({ severity: 'error', summary: 'Error', detail: 'No data found' });
              this.userService.logUserActivity('Export CSV', null, {
                'Text1': 'No data found',
                'Text2': 'User Filter Parameters: ' + JSON.stringify(this.DefaultFilterArray.filter((filterParam:any) => (filterParam.values != '' || filterParam.values.length > 0)))
              });
            }
            this.emitterService.exportToCSVData.emit(true);
      },
      error: (err: HttpErrorResponse) => {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error while Exporting' });
        this.userService.logUserActivity('Export CSV', null, {
          'Text1': 'Error while Exporting',
          'Text2': 'User Filter Parameters: ' + JSON.stringify(this.DefaultFilterArray.filter((filterParam:any) => (filterParam.values != '' || filterParam.values.length > 0)))
        });
      }
    });    
  }

  ngOnDestroy() {
    if(this.subscription)
  this.subscription.unsubscribe();
  }
}